import React from 'react'
import CardFeedCreate from 'src/app/CardFeedCreate/CardFeedCreate'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { createCardFeedRouteProps } from 'src/navigation/routeProps'

const CardFeedCreateAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsCardFeedCreate,
  routeProps: createCardFeedRouteProps,
  component: <CardFeedCreate />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default CardFeedCreateAppRoute
